<template>
  <v-card class="fill-height">

    <div class="d-flex flex-column pa-4 post-actions">
      <v-btn color="red" dark fab small class="mb-4">
        <v-icon>mdi-record</v-icon>
      </v-btn>
      <v-btn color="grey" dark fab small class="mb-4" :disabled="isOwner">
        <v-icon>mdi-alert</v-icon>
      </v-btn>
      <v-btn color="primary" dark fab small>
        <v-icon>mdi-share-variant</v-icon>
      </v-btn>
    </div>

    <video width="100%" height="100%" ref="video">
      <source src="https://www.w3schools.com/html/mov_bbb.mp4" type="video/mp4">
    </video>

    <div class="post-info">
      <rating-input />

      <v-list-item dark :to="{ name: 'profile', params: { userId: post.userId } }">
        <v-list-item-avatar v-if="false">
          <v-img src="" />
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">Birch Periera</v-list-item-title>
          <v-list-item-subtitle class="overline">Friday, 3:30 PM</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-btn icon large color="purple"><v-icon>mdi-message</v-icon></v-btn>
        </v-list-item-action>
        <v-list-item-action>
          <v-btn icon large color="green" v-if="isSubscribed">
            <v-icon>mdi-bookmark-check</v-icon>
          </v-btn>
          <v-btn icon large v-else>
            <v-icon>mdi-bookmark-outline</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </div>

  </v-card>
</template>

<style scoped>
.post-actions {
  position: absolute;
  right: 0;
  z-index: 1;
}

video {
  background-color: black;
}

.post-info {
  position: absolute;
  bottom: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}
</style>

<script>
import RatingInput from '@/components/RatingInput.vue';

export default {
  name: 'video-card',
  components: {
    RatingInput
  },
  props: [ 'post' ],
  data() {
    return {
    };
  },
  computed: {
    isOwner() {
      return false;
    },
    isSubscribed() {
      return true;
    }
  }
}
</script>
